import * as THREE from "three/webgpu";
import RAPIER from '@dimforge/rapier3d-simd-compat';

const app = document.querySelector('game-app');

/**
 * Base class for game objects
 */

// https://threejs.org/docs/?q=orbit#api/en/core/EventDispatcher

export class GameObject extends THREE.EventDispatcher {
    constructor() {
        super();

        this.uuid = null;
        this.links = [];
    }

    setPosition( index, position ) {
        if (this.links.length === 0) {
            return;
        }
        this.links[index].rigidBody.setTranslation( position );
        this.links[index].visual.position.copy( position );
    }

    getPosition( index = 0 ) {
        if (this.links.length === 0) {
            return;
        }
        const position = this.links[index].visual.position;
        return position;
    }

    setRotationFromEuler( index, euler ) {
        if (this.links.length === 0) {
            return;
        }
        this.links[index].rigidBody.setRotation( new THREE.Quaternion().setFromEuler( euler ) );
        this.links[index].visual.setRotationFromEuler( euler );
    }

    renderingUpdate( elaspdedTime ) {
        // this.dispatchEvent({ type: 'update' });
    }

    updatePhysics( timestep ) {
        
    }
}

/**
 * 
 * @param {*} bodyType 
 * @param {*} colliders 
 * @returns 
 */
export const createRigidBody = ( bodyType, colliders ) => {
    // console.log(engine.world);
    let rigidBodyDesc;
        switch (bodyType) {
            case 'dynamic':
                rigidBodyDesc = RAPIER.RigidBodyDesc.dynamic()
                    // .setTranslation(
                    //     physicalDesc.position.x,
                    //     physicalDesc.position.y,
                    //     physicalDesc.position.z);
                break;
            case 'fixed':
                rigidBodyDesc = RAPIER.RigidBodyDesc.fixed()
                    // .setTranslation(
                    //     physicalDesc.position.x,
                    //     physicalDesc.position.y,
                    //     physicalDesc.position.z);
                break;
            case 'kinematic_pos':
                rigidBodyDesc = RAPIER.RigidBodyDesc.kinematicPositionBased()
                    // .setTranslation(
                    //     physicalDesc.position.x,
                    //     physicalDesc.position.y,
                    //     physicalDesc.position.z);
                break;
            case 'kinematic_vel':
                rigidBodyDesc = RAPIER.RigidBodyDesc.kinematicVelocityBased()
                    // .setTranslation(
                    //     physicalDesc.position.x,
                    //     physicalDesc.position.y,
                    //     physicalDesc.position.z);
                break;
            default:
                throw new Error("Unsupported body type!")
        }
    const rigidBody = app.world.createRigidBody(rigidBodyDesc);
    // console.log(colliders);
    colliders.forEach( collider => {
        // console.log(collider);
        app.world.createCollider(collider, rigidBody);
    });

    return rigidBody;
}

/**
 * Creates a new 3D box collider.
 * @param {number} width The width of the box.
 * @param {number} height The height of the box.
 * @param {number} depth The depth of the box.
 * @returns { RAPIER.ColliderDesc } A cuboid collider (RAPIER.ColliderDesc)
 */
export const createBoxCollider = (width, height, depth) => {
    return RAPIER.ColliderDesc.cuboid(width/2, height/2, depth/2);
}
/**
 * Create a trimesh collider.
 * @param {THREE.BufferGeometry} geometry 
 * @returns {RAPIER.ColliderDesc}
 */
export const createTrimeshCollider = (geometry) => {
    return RAPIER.ColliderDesc.trimesh(
        new Float32Array(geometry.attributes.position.array),
        new Uint32Array(geometry.index.array)
    );
}
